import { Link } from "react-router-dom";
import { newsArticles } from "@/mocks/content";

export default function NewsSection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">漫画资讯</h2>
            <p className="mt-2 text-sm text-foreground-600">最新评测、互动与追漫情报</p>
          </div>
          <Link to="/category/love" className="hidden items-center gap-1 text-sm text-primary-600 hover:text-primary-700 sm:inline-flex">
            更多资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {newsArticles.map((a) => (
            <Link
              key={a.id}
              to={`/article/${a.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={a.cover}
                  alt={`${a.title} 资讯配图`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-1 text-xs text-background-50">{a.category}</span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 text-sm font-semibold leading-6 text-foreground-950 group-hover:text-primary-600">
                  {a.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-xs leading-5 text-foreground-600">{a.summary}</p>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-calendar-line"></i>
                  <span>{a.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}